// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"0bcc17e3","787":"2dbfbc28"}[chunkId] + ".chunk.js";
};